import {
  INTEGRATION_TYPES,
  type IntegrationDefinition,
  type IntegrationEndpointInfo,
} from '../types'

export const DEFAULT_OPENGOV_CONFIG = {}

const OPENGOV_ENDPOINTS: IntegrationEndpointInfo[] = [
  {
    name: 'Create Work Order',
    method: 'POST',
    description: 'Create a new OpenGov EAM work order',
    toolName: 'create_work_order',
  },
  {
    name: 'Update Work Order',
    method: 'PATCH',
    description: 'Update an existing OpenGov EAM work order',
    toolName: 'update_work_order',
  },
  {
    name: 'Get Work Order',
    method: 'GET',
    description: 'Get a single OpenGov EAM work order by OID',
    toolName: 'get_work_order',
  },
  {
    name: 'List Work Orders',
    method: 'GET',
    description: 'List OpenGov EAM work orders with optional filters',
    toolName: 'list_work_orders',
  },
]

export const opengovIntegration: IntegrationDefinition = {
  id: INTEGRATION_TYPES.OPENGOV,
  title: 'OpenGov EAM',
  defaultConnectionName: 'OpenGov EAM',
  logo: 'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/opengov-logo.png',
  icon: 'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/opengov-icon.png',
  cardDescription: 'Connect to OpenGov EAM to manage work orders and infrastructure assets.',
  modalDescription:
    'Connect to OpenGov Enterprise Asset Management to create and manage work orders. The integration will automatically configure all available API endpoints.',
  formFields: [
    {
      name: 'host',
      label: 'Base URL',
      placeholder: 'e.g., your-org.opengov.com',
      helperText: 'The OpenGov API host for your organization (without https://)',
      required: true,
      type: 'text',
    },
    {
      name: 'username',
      label: 'Username',
      placeholder: 'Enter your OpenGov API username',
      helperText: 'Your OpenGov API username',
      required: true,
      type: 'text',
    },
    {
      name: 'password',
      label: 'Password',
      placeholder: 'Enter your OpenGov API password',
      helperText: 'Your password is stored securely and encrypted',
      required: true,
      type: 'password',
    },
  ],
  apiConfig: {
    createEndpoint: '/integrations/generate-opengov-integration/',
    buildPayload: (formData, config, _organizationId, organizationIdentityId) => {
      const host = formData.host.replace(/^https?:\/\//, '').replace(/\/+$/, '')
      return {
        organization_identity_id: organizationIdentityId,
        username: formData.username,
        password: formData.password,
        base_url: `https://${host}`,
        connection_name: formData.connectionName || 'OpenGov EAM',
        excluded_endpoints: (config.excluded_endpoints as string[]) || [],
      }
    },
    authTokenName: 'password',
    buildTestCredentials: (formData) => {
      const host = formData.host.replace(/^https?:\/\//, '').replace(/\/+$/, '')
      return {
        base_url: `https://${host}`,
        username: formData.username,
        password: formData.password,
      }
    },
  },
  defaultConfig: { ...DEFAULT_OPENGOV_CONFIG },
  endpoints: OPENGOV_ENDPOINTS,
}
